import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import * as classNames from 'classnames';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import Image from '../Image';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      flex: '0 0 100%',

      [mediaQueries.Mobile]: {
        paddingLeft: spacing.Gutter.Mobile / 2,
        paddingRight: spacing.Gutter.Mobile / 2,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
        // paddingBottom: spacing.Gutter.Tablet,
        paddingTop: 10,
        paddingBottom: 20,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
        // paddingBottom: spacing.Gutter.Laptop,

        paddingTop: 10,
        paddingBottom: 20,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
        // paddingBottom: spacing.Gutter.Desktop,

        paddingTop: 10,
        paddingBottom: 20,
      },
    },

    panelHalf: {
      flex: '0 0 100%',
      [mediaQueries.AfterMobile]: {
        flex: '0 0 50%',
      },
    }
  }));

export type PanelImage = PanelImageDto;

type Props = PanelImage;

const PanelImages: FC<Props> = ({ Image: image, Size }) => {
  const cls = useStyles();
  const sizes = Size === 'Full' ?
    '(max-width: 690px) 100vw,(max-width: 1024px) 100vw, 1100px' : '(max-width: 690px) 100vw, 50vw';

  return (
    <div className={classNames(cls.root, Size === "Half" && cls.panelHalf)}>
      <Image pictureRef={image} sizes={sizes} />
    </div>
  );
};

export default PanelImages;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelImage.tsx